import { useNavigate } from "react-router-dom";
import "../styles/output.css";
import Button from "../components/basicComponents/button";
import TextInput from "../components/basicComponents/text-input";
import personIcon from "../assets/SVGs/person.svg";
import eyeIcon from "../assets/SVGs/eye.svg";
import phoneIcon from "../assets/SVGs/phone.svg";
import emailIcon from "../assets/SVGs/mail.svg";
import passIcon from "../assets/SVGs/pass.svg";
import arrowRight from "../assets/SVGs/arrow-right.svg";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../state-management/store"; // Import RootState type
import theme from "../config/theme";
import * as Icons from "../assets/SVGs/index";
import ToggleChangeTheme from "../components/toggle-change-theme"; // Adjust the path as necessary
import {
    setAlert,
    setAlertSeverity,
    setAlertContext,
} from "../state-management/actions/alerts-actions";
import { ReactComponent as LoginSvg } from "../assets/SVGs/login-svg.svg";

import { useFormik } from "formik";
import { registerSchema } from "../utils/validation-schema"; // Import schema
import { userRegister } from "../state-management/actions/auth-actions";

const RegisterPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const themeMode = useSelector(
        (state: RootState) => state.globalState.theme
    );
    const mode = themeMode === "light" ? theme.light : theme.dark;
    const formik = useFormik({
        initialValues: {
            firstname: "",
            lastname: "",
            username: "",
            email: "",
            mobile: "",
            password: "",
            confirmPassword: "",
        },
        validationSchema: registerSchema, // Applying validation schema
        onSubmit: async (values) => {
            try {
                const data = {
                    firstname: values.firstname,
                    lastname: values.lastname,
                    username: values.username,
                    email: values.email,
                    phone: values.mobile,
                    password: values.password,
                    confirmPassword: values.confirmPassword,
                };
                console.log(data, "ffff");
                await userRegister(data)(dispatch)
                    .then((response) => {
                        dispatch(setAlert(true));
                        dispatch(setAlertSeverity("success"));
                        dispatch(
                            setAlertContext("ثبت نام با موفقیت صورت پذیرفت")
                        );
                        console.log(response);
                    })
                    .catch((error: any) => {
                        dispatch(setAlert(true));
                        dispatch(setAlertSeverity("error"));
                        dispatch(
                            setAlertContext(JSON.stringify(error.message))
                        );
                        console.log("Error response:", error.message);
                    });
            } catch (error: any) {
                console.log("Error:", error);
            }
        },
    });

    return (
        <div
            className="w-full min-h-screen flex flex-col items-center justify-center"
            style={{ backgroundColor: mode.backgroundColor.bgPrimary }}
        >
            <div className="grid md:grid-cols-2 items-center max-w-4xl max-md:max-w-lg w-full m-4 shadow-[0_2px_10px_-3px_rgba(128,128,128,0.3)] rounded-lg border border-[#0e9f6e3d]">
                <div
                    className="md:h-full rounded-lg p-8 flex justify-center items-center hidden md:flex"
                    style={{ backgroundColor: mode.backgroundColor.bgGray }}
                >
                    <LoginSvg style={{ color: "green" }} />
                </div>
                <div className="md:max-w-full w-full md:p-14 p-5">
                    <div className="p-2 flex flex-col items-center justify-center">
                        <p
                            style={{ color: mode.color.textPrimary }}
                            className="text-xl font-bold my-2"
                        >
                            ثبت نام!
                        </p>
                    </div>
                    <form onSubmit={formik.handleSubmit}>
                        <TextInput
                            name="firstname"
                            label="نام"
                            placeholder="نام خود را وارد کنید"
                            RightIcon={<img src={personIcon} alt="person" />}
                            value={formik.values.firstname}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            helperText={
                                formik.touched.firstname &&
                                formik.errors.firstname
                                    ? formik.errors.firstname
                                    : undefined
                            }
                        />
                        <TextInput
                            name="lastname"
                            label="نام خانوادگی"
                            placeholder="نام خانوادگی خود را وارد کنید"
                            RightIcon={<img src={personIcon} alt="person" />}
                            value={formik.values.lastname}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            helperText={
                                formik.touched.lastname &&
                                formik.errors.lastname
                                    ? formik.errors.lastname
                                    : undefined
                            }
                        />
                        <TextInput
                            name="username"
                            label="نام کاربری"
                            placeholder="نام کاربری خود را وارد کنید"
                            RightIcon={<img src={personIcon} alt="person" />}
                            value={formik.values.username}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            helperText={
                                formik.touched.username &&
                                formik.errors.username
                                    ? formik.errors.username
                                    : undefined
                            }
                        />
                        <TextInput
                            name="email"
                            label="ایمیل"
                            placeholder="ایمیل خود را وارد کنید"
                            RightIcon={<img src={emailIcon} alt="email" />}
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            helperText={
                                formik.touched.email && formik.errors.email
                                    ? formik.errors.email
                                    : undefined
                            }
                        />
                        <TextInput
                            name="mobile"
                            label="موبایل"
                            placeholder="شماره موبایل خود را وارد کنید"
                            RightIcon={<img src={phoneIcon} alt="phone" />}
                            value={formik.values.mobile}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            helperText={
                                formik.touched.mobile && formik.errors.mobile
                                    ? formik.errors.mobile
                                    : undefined
                            }
                        />
                        <TextInput
                            name="password"
                            label="رمز ورود"
                            placeholder="رمز عبور خود را وارد کنید"
                            RightIcon={<img src={passIcon} alt="password" />}
                            LeftIcon={<img src={eyeIcon} alt="eye" />}
                            secureTextEntry={true}
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            helperText={
                                formik.touched.password &&
                                formik.errors.password
                                    ? formik.errors.password
                                    : undefined
                            }
                        />
                        <TextInput
                            name="confirmPassword"
                            label="تکرار رمز ورود"
                            placeholder="رمز عبور خود را مجدد وارد کنید"
                            LeftIcon={<img src={eyeIcon} alt="eye" />}
                            RightIcon={<img src={passIcon} alt="password" />}
                            secureTextEntry={true}
                            value={formik.values.confirmPassword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            helperText={
                                formik.touched.confirmPassword &&
                                formik.errors.confirmPassword
                                    ? formik.errors.confirmPassword
                                    : undefined
                            }
                        />
                        <Button
                            title="ثبت نام"
                            type="submit"
                            color={"white"}
                            backgroundColor="#2D667F"
                            paddingx="143px"
                            paddingy="10px"
                        />
                    </form>
                    <p
                        className="text-mobasher-green text-right cursor-pointer flex justify-strat items-center w-full text-xs mt-2"
                        onClick={() => navigate("/login-page")}
                    >
                        ورود به حساب
                        <img src={arrowRight} alt="arrow" />
                    </p>
                </div>
            </div>
            <div className="w-full justify-center pb-2">
     <div className="flex justify-around mt-4">
                <ToggleChangeTheme
                    lightIcon={
                        <Icons.MoonIcon
                            fill="#000000"
                            className="absolute bottom-[6%] left-[0%] h-6 w-6 rounded-full bg-[#ffffff] transition-all duration-500 peer-checked:transform peer-checked:translate-x-full"
                        />
                    }
                    darkIcon={
                        <Icons.SunIcon
                            fill="#ffffff"
                            className="absolute bottom-[6%] left-[-20%] h-6 w-6 rounded-full bg-[#25282D] transition-all duration-500 peer-checked:transform peer-checked:translate-x-full"
                        />
                    }
                />
            </div>
     </div>
        </div>
    );
};

export default RegisterPage;
